"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var ar_EG_1 = __importDefault(require("antd/lib/locale-provider/ar_EG"));
var en_US_1 = __importDefault(require("antd/lib/locale-provider/en_US"));
var ar_1 = __importDefault(require("common/translations/ar"));
var en_1 = __importDefault(require("common/translations/en"));
var i18next_1 = __importDefault(require("i18next"));
var moment_1 = __importDefault(require("moment"));
require("moment/locale/ar");
require("moment/locale/tr");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Settings_1 = require("./Settings");
i18next_1.default.use(react_i18next_1.initReactI18next).init({
    fallbackLng: 'en',
    lng: 'en',
    resources: {
        en: {
            translation: en_1.default,
        },
        ar: {
            translation: ar_1.default,
        },
    },
    interpolation: {
        escapeValue: false,
        format: function (value, format) {
            if (format === 'uppercase') {
                return value.toUpperCase();
            }
            if (value instanceof Date) {
                return (0, moment_1.default)(value).format(format);
            }
            return value;
        },
    },
});
var antLocales = {
    ar: ar_EG_1.default,
    en: en_US_1.default,
};
function Locale(_a) {
    var children = _a.children;
    var locale = (0, Settings_1.useSettings)()[0].locale;
    (0, react_1.useEffect)(function () {
        if (locale) {
            i18next_1.default.changeLanguage(locale);
        }
    }, [locale]);
    return (
    // <div dir={direction}>
    (0, jsx_runtime_1.jsx)(react_i18next_1.I18nextProvider, __assign({ i18n: i18next_1.default }, { children: (0, jsx_runtime_1.jsx)(antd_1.ConfigProvider, __assign({ locale: antLocales[locale] }, { children: children })) }))
    // </div>
    );
}
exports.default = Locale;
